import qs from "qs";
import { BreadcrumbsLength, ReportTypeEnum } from "../constants/constants";
import { ROUTE_DYNAMIC_VARIABLE } from "../constants/url-config";
import { BreadcrumbModel } from "../models/breadcrumb.model";
import { authorizedRouters, Route, RoutingEnum } from "../routing";
import UTIL from "./utils";

const removeDynamicPath = (href: string) => {
    let newhref = href;
    Object.values(ROUTE_DYNAMIC_VARIABLE).forEach(function (i) {
        newhref = newhref.replace(i, "");
    });
    return newhref;
};

const getMenuUpdateByQuery = (menu: Route): Route => {
    const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    const group = Number(query.group);
    const type = query.type?.toString() as ReportTypeEnum;

    switch (menu.id) {
        case RoutingEnum.ECAPReportGroup:
            menu.title = UTIL.getECapReportGroupDisplay(group);
            menu.href = `${menu.href}?group=${group}`
            break;
        case RoutingEnum.EcapReports:
            menu.title = UTIL.getECapReportTypeDisplay(type);
            menu.href = `${menu.href}?group=${group}&type=${type}`;
            break;
        default:
            break;
    }
    return menu;

}

const checkLink = (link: string | undefined, menu: Route) => {

    if (menu.href === undefined || link === undefined) {
        return false;
    }

    if (menu.href === "" || menu.href === "/") {
        return link === menu.href;
    }

    return link.includes(removeDynamicPath(menu.href));
}

const getCurrentMenuId = (link?: string) => {
    const menuItems = authorizedRouters.filter(p => checkLink(link, p));

    if (!menuItems || !menuItems.length) {
        return 0
    }

    return Math.max(...menuItems.map(p => p.id ?? 0));
}

const getMenuSeletedKeys = (link: string) => {
    const selected: string[] = [];

    const setSelected = (id: number | undefined) => {
        if (id) {
            const menu = authorizedRouters.find(p => p.id === id);
            if (menu && menu.id) {

                if (menu.showOnMenu) {
                    selected.push(menu.id.toString());
                }

                if (menu.parentId && selected.indexOf(menu.parentId.toString()) === -1) {
                    setSelected(menu.parentId);
                }
            }
        }
    }

    const currentMenuId = getCurrentMenuId(link);
    if (currentMenuId) {
        setSelected(currentMenuId);
    }

    return selected;

}

const getBreadcrumbs = (breadcrumb: BreadcrumbModel) => {
    let breadcrumbs: BreadcrumbModel[] = [];


    const setSelected = (id: number | undefined) => {
        if (id) {
            let menu = authorizedRouters.find(p => p.id === id);
            if (menu && menu.id) {
                const newMenu = menu.title ? menu : getMenuUpdateByQuery({ ...menu });
                const b: BreadcrumbModel = {
                    title: newMenu.title || "",
                    href: newMenu.href
                }
                breadcrumbs.unshift(b);

                if (menu.parentId) {
                    setSelected(menu.parentId);
                }

            }
        }
    }


    const currentMenuId = getCurrentMenuId(breadcrumb.href);
    if (currentMenuId) {
        const currentMenu = authorizedRouters.find(p => p.id === currentMenuId);
        setSelected(currentMenu?.parentId);
        breadcrumbs.push(breadcrumb);

    }

    const length = breadcrumbs.length;
    if (length > BreadcrumbsLength) {
        breadcrumbs = breadcrumbs.filter((p, index) => ((length - index) <= BreadcrumbsLength));
    }
    return breadcrumbs;
}

export const ROUTING_HELPER = {
    getMenuSeletedKeys,
    getBreadcrumbs,
    getCurrentMenuId
}